var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9359 6.01375L16.9359 3.01375C16.3359 2.78708 15.6693 2.78708 15.0693 3.01375L7.06927 6.01375C6.02927 6.41375 5.33594 7.40042 5.33594 8.52042V14.7871C5.33594 21.3738 9.69594 27.5471 15.6159 29.2271C15.8693 29.2938 16.1359 29.2938 16.3759 29.2271C22.3093 27.5471 26.6693 21.3738 26.6693 14.7871V8.52042C26.6693 7.40042 25.9759 6.41375 24.9359 6.01375ZM19.7359 19.7204C19.2159 20.2404 18.3759 20.2404 17.8559 19.7338L16.0026 17.8938L14.1493 19.7338C13.9 19.9831 13.5618 20.1231 13.2093 20.1231C12.8567 20.1231 12.5186 19.9831 12.2693 19.7338C12.02 19.4844 11.8799 19.1463 11.8799 18.7938C11.8799 18.4412 12.02 18.1031 12.2693 17.8538L14.1226 16.0004L12.2693 14.1471C12.02 13.8978 11.8799 13.5597 11.8799 13.2071C11.8799 12.8545 12.02 12.5164 12.2693 12.2671C12.5186 12.0178 12.8567 11.8777 13.2093 11.8777C13.5618 11.8777 13.9 12.0178 14.1493 12.2671L16.0026 14.1204L17.8559 12.2671C18.1052 12.0178 18.4434 11.8777 18.7959 11.8777C19.1485 11.8777 19.4866 12.0178 19.7359 12.2671C19.9852 12.5164 20.1253 12.8545 20.1253 13.2071C20.1253 13.5597 19.9852 13.8978 19.7359 14.1471L17.8959 16.0004L19.7359 17.8404C20.2559 18.3604 20.2559 19.2004 19.7359 19.7204Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorimg);
export default __webpack_public_path__ + "static/media/error img.7477689d.svg";
export { ForwardRef as ReactComponent };